import SearchPage from '../../search/[search]';

export default SearchPage;
